import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

export const Section = css`
  margin-bottom: ${theme.space[4]};
`;

export const HeaderSection = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5em;
  padding-bottom: 1em;
  border-bottom: 1px solid ${theme.colors.darkBlues[10]};

  .title {
    margin: 0;
    padding: 0;
    border: none;
    font-size: ${theme.fontSizes[3]};
    line-height: ${theme.lineHeights[4]};
    font-weight: ${theme.fontWeights.semibold};
  }

  .subtitle {
    color: ${theme.colors.darkBlues[75]};
    font-size: ${theme.fontSizes[0]};
  }

  .downloadAllLink {
    font-size: ${theme.fontSizes[2]};
    margin-top: 0.5em;
    align-self: flex-end;
    cursor: pointer;
    i {
      margin-right: ${theme.space[2]};
    }
  }
`;

export const fancyDownload = css`
  text-align: center;
  img {
    width: 33%;
    margin-bottom: ${theme.space[4]};
  }
  .title {
    font-size: ${theme.fontSizes[3]};
    line-height: ${theme.lineHeights[4]};
    font-weight: ${theme.fontWeights.semibold};
    margin-bottom: ${theme.space[2]};
  }
  .subtitle {
    font-size: ${theme.fontSizes[2]};
    margin-bottom: ${theme.space[4]};
  }
`;

export const container = css`
  background-color: ${theme.colors.blues[5]};
  border: 1px dashed ${theme.colors.blues[50]};
  padding: 3em 0em;
  display: flex;
  flex-direction: column;

  .uploadIcon {
    color: ${theme.colors.blues[100]};
    margin-bottom: 1em;
  }

  .browseLink {
    cursor: pointer;
  }

  .dropzoneText {
    font-size: ${theme.fontSizes[2]};
    font-weight: ${theme.fontWeights.semibold};
  }
`;

export const addFilesPanel = css`
  .dropZone {
    text-align: center;
    margin: 2em 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
